import { isMobile, resizeGame } from '@pascal/pascal-core';

const maxHeight = 700;
const maxWidth = 1196;
const target = document.querySelector('#root');

export const resizeGameHandler = () => {
  resizeGame(maxHeight, maxWidth, target);
};

export const setupResolution = () => {
  if (isMobile()) {
    document.documentElement.classList.add('is-mobile');
  } else {
    resizeGameHandler();
    window.addEventListener('resize', resizeGameHandler);
    document.documentElement.classList.add('is-web');
  }
};
